import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { OpenSnackbarAction, ShowSpinnerAction, HideSpinnerAction } from '@ngxs-store/ui-store/ui.actions';
import { ProblemDetail, SnackbarType } from '@core/models';
import { Router } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { ClearTokenAction } from '@ngxs-store/auth-store/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class HyperInterceptorService implements HttpInterceptor {
  httpRequestCounter = 0;

  constructor(private store: Store, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.startSpinner();
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.statusText === "Unauthorized") {
          this.store.dispatch(new ClearTokenAction());
          this.store.dispatch(new Navigate(['/auth/login']))
        }
        this.stopSpinner();
        this.processError(error);
        return throwError(error);
      }),
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.stopSpinner();
        }
      })
    );
  }

  processError(error: HttpErrorResponse) {
    if (error instanceof HttpErrorResponse && error.error instanceof Blob && error.error.type === 'application/problem+json') {
      const reader = new FileReader();

      reader.onload = (e: Event) => {
        const problemDetail = JSON.parse((e.target as any).result) as ProblemDetail;
        this.displayProblemDetailSnackbar(problemDetail);
      };

      reader.readAsText(error.error);
    } else {
      this.displaySuperSnackbar(error.message);
    }
  }

  displayProblemDetailSnackbar(problemDetail: ProblemDetail) {
    if (environment.globalHttpErrorSnackbar) {
      this.store.dispatch(
        new OpenSnackbarAction({
          type: SnackbarType.ProblemDetail,
          problemDetail
        })
      );
    }
  }

  displaySuperSnackbar(message: string) {
    if (environment.globalHttpErrorSnackbar) {
      this.store.dispatch(
        new OpenSnackbarAction({
          message,
          type: SnackbarType.Super
        })
      );
    }
  }

  startSpinner() {
    if (environment.globalHttpActivitySpinner) {
      this.httpRequestCounter++;

      if ((this.httpRequestCounter === 1)) {
        this.store.dispatch(new ShowSpinnerAction());
      }
    }
  }

  stopSpinner() {
    if (environment.globalHttpActivitySpinner) {
      this.httpRequestCounter--;
      if (this.httpRequestCounter === 0) {
        this.store.dispatch(new HideSpinnerAction());
      }
    }
  }
}
